<form *ngIf="form" [formGroup]="form" (ngSubmit)="createEntity()" class="generic-form-fields">
  <dx-text-box formField [label]="'common.code' | translate | ucfirst" required formControlName="code"/>
  <dx-text-area formField [label]="'common.name' | translate | ucfirst" required formControlName="name"/>
  <dx-select-box [dataSource]="valueTypes" formField [label]="'entity.technicalFeature.valueTypeId' | translate | ucfirst" required formControlName="valueTypeId"/>
  <div *ngIf="form.controls['valueTypeId'].value === 4 || form.controls['valueTypeId'].value === 5" >
    <dx-sortable
      style="width: 100%;"
      filter=".dx-tag-content"
      dropFeedbackMode="indicate"
      itemOrientation="horizontal"
      [allowReordering]="true"
      (onReorder)="reorder($event)"
    >
      <dx-tag-box
        dataField="values"
        [scrollable]="true"
        (onInitialized)="tagBoxValues = $event.component"
        [multiline]="false"
        width="100%"
        formField
        formControlName="values"
      />
    </dx-sortable>
  </div>
  <dx-text-area formField formControlName="formula" />
</form>
